<template>
  <div style="width: 100%; height: 100%"  class="charts" :id="id" />
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      ChartLineGraph: null,
    };
  },
  watch: {
    option: {
      handler(newvalue, oldvalue) {
        this.initChart(this.id, newvalue);
      },
      deep: true,
      immediate: true,
    },
  },
  props: {
    id: {
      type: String,
      default: "chart",
    },
    option: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (this.ChartLineGraph) {
      this.ChartLineGraph.clear();
    }
  },

  methods: {
    initChart() {
      if (
        this.ChartLineGraph != null &&
        this.ChartLineGraph != "" &&
        this.ChartLineGraph != undefined
      ) {
        this.ChartLineGraph.dispose(); //销毁
      }
      let myChart = document.getElementById(this.id);
      let _this = this;
      if (myChart) {
        _this.ChartLineGraph = echarts.init(myChart);
        let noData = false;
        if(typeof(this.option) == 'undefined' || typeof(this.option.series) == 'undefined' || this.option.series.length == 0) {
          noData = true;
        }
        if (noData) {
          _this.ChartLineGraph.showLoading({
            text: "No Data",
            color: "#ffffff",
            textColor: "#8a8e91",
            maskColor: "rgba(204, 204, 204, 0.1)",
          });
        } else {
          _this.ChartLineGraph.setOption(this.option);
        }

        window.addEventListener("resize", function () {
          _this.ChartLineGraph.resize();
        });
      }
    },
  },
};
</script>
<style scoped>
.charts {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/charts/ChartItem.vue